import React from 'react'
import './styles.css'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faShareAlt
} from "@fortawesome/free-solid-svg-icons";

const igIcon = '/instagram.png'
const fbIcon = '/facebook.png'

export default class Contact extends React.Component{
    render(){
        return(
            <div className="div-contact">
                <div className="social">
                    <FontAwesomeIcon icon={faShareAlt}/>
                    <p>Sociálne siete</p>
                    <div className="social-media">
                        <a href="https://www.instagram.com/miroslavbabincak/" target="_blank" rel="noreferrer">
                            <img className="social-icons" src={igIcon} alt="ikona Instagram"/>
                        </a>
                        <a href="https://www.facebook.com/miroslav.babincak" target="_blank" rel="noreferrer">
                            <img className="social-icons" src={fbIcon} alt="ikona Facebook"/>
                        </a>
                    </div>
                </div>
                {/*<div className="div-direct-contact">
                    <div className="direct-contact direct-contact-right">
                        <FontAwesomeIcon icon={faMailBulk} />
                        <p>Email</p>
                        <a href="mailto: babincak.m@gmail.com">babincak.m@gmail.com</a>
                    </div>
                    <div className="direct-contact direct-contact-left">
                        <FontAwesomeIcon icon={faPhone} />
                        <p>Telefónny kontakt</p>
                        <a href="tel: babincak.m@gmail.com">+421 907 618 680</a>
                    </div>
                </div>*/}
            </div>
        )
    }
}